import moment from 'moment';

import {
  AccountConnectorServiceEnum,
  EnrichmentHealthMetric,
  useEnrichmentHealthMetricMetricQuery,
} from '~/generated/graphql';

type UseQueryEnrichmentMetricArgs = {
  queryStartDate: moment.Moment;
  queryEndDate: moment.Moment;
  metricName: string;
  externalType: AccountConnectorServiceEnum;
};

type UseQueryEnrichmentMetricReturn = {
  currentRangeData: EnrichmentHealthMetric | undefined;
  currentRangeLoading: boolean;
  pastRangeLoading: boolean;
  pastRangeData: EnrichmentHealthMetric | undefined;
};

export const useQueryEnrichmentMetric = ({
  queryStartDate,
  queryEndDate,
  metricName,
  externalType,
}: UseQueryEnrichmentMetricArgs): UseQueryEnrichmentMetricReturn => {
  const {
    data: { enrichmentHealthMetric: currentRangeMetric } = {},
    loading: currentRangeLoading,
  } = useEnrichmentHealthMetricMetricQuery({
    fetchPolicy: 'no-cache',
    variables: {
      metricName: metricName,
      externalType: externalType,
      startDate: queryStartDate.utc().format('YYYY-MM-DD'),
      endDate: queryEndDate.utc().format('YYYY-MM-DD'),
    },
  });
  const duration = moment(queryEndDate).diff(queryStartDate, 'days');
  const prevRangeEndDate = moment(queryStartDate).add(-1, 'days');
  const prevRangeStartDate = moment(prevRangeEndDate).add(-duration, 'days');
  const {
    data: { enrichmentHealthMetric: pastRangeMetric } = {},
    loading: pastRangeLoading,
  } = useEnrichmentHealthMetricMetricQuery({
    fetchPolicy: 'no-cache',
    variables: {
      metricName: metricName,
      externalType: externalType,
      startDate: prevRangeStartDate.utc().format('YYYY-MM-DD'),
      endDate: prevRangeEndDate.utc().format('YYYY-MM-DD'),
    },
  });

  return {
    currentRangeData: currentRangeMetric,
    currentRangeLoading: currentRangeLoading,
    pastRangeLoading: pastRangeLoading,
    pastRangeData: pastRangeMetric,
  };
};
